export const convertDateToBackendFormat = (date: string): string => {
	const [day, month, year] = date.split('/');
	return `${year}-${month}-${day}`;
};

export const formatDateToDisplay = (date: string): string => {
	if (!date) return '';
	const match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	return match ? `${match[3]}/${match[2]}/${match[1]}` : date;
};
